import { QuoteProductID } from "./QuoteProductID";

export const GetHandoffPath = (id) => {
  switch (id) {
    case QuoteProductID.HAVEN_TERM_PRODUCT_ID:
      return "/handoff-haven";
    case QuoteProductID.HAVEN_SI_PRODUCT_ID:
      return "/handoff-havensi";
    case  QuoteProductID.LGA_PRODUCT_ID:
      return "/handoff-lga";
    case QuoteProductID.BESTOW_PRODUCT_ID:
      return "/handoff-bestow";
    default:
      return "";
  }
}


// WEBPACK FOOTER //
// ./src/components/Quoters/Common/GetHandoffPath.js